import React from 'react';
import useReactRouter from 'use-react-router';
import { SITE_URL } from 'env';
import { isIosDevice, isSafariBrowser } from 'utils/utils';
import { RouteParams } from 'components/custom-route/custom-route';
import { BizonScreenWrapper } from 'components/commons';
import LoadingFallback from './loading-fallback';
import ModalSafariRedirect from './components/safari-redirect-modal'
import { GenericErrorLayout } from '../direto/error-message';
import { ApolloClientName } from 'apollo-client-factory';
import {
    useGenerateWorthyCreditFormMutation
} from 'generated/credit-analysis-graphql';
import './bizon-screen.styles.scss';

type WorthyCreditProps = {
    onComplete(): void,
};


const WorthyCreditQuestionnaire: React.FC<WorthyCreditProps> = ({ onComplete }): JSX.Element => {
    const [worthyCreditFormUrl, setWorthyCreditFormUrl] = React.useState('');
    const [isError, setIsError] = React.useState(false);
    const { match: { params: { loanApplicationId } } } = useReactRouter<RouteParams>();

    const [generateWorthyCreditFormHook] = useGenerateWorthyCreditFormMutation({
        context: { clientName: ApolloClientName.CreditAnalysisApi },
    });

    const eventHandler = (e) => {
        const message = e.data;

        if (message.type === 'questionnaire-last-page') {
            setTimeout(() => {
                onComplete();
            }, 3000);
        }
    }

    React.useEffect(() => {
        const generateWorthyCreditFormAsync = async () => {
            try {
                const { data: { generateWorthyCreditForm: { questionnaireUrl } } } = await generateWorthyCreditFormHook({
                    variables: {
                        loanApplicationId
                    }
                });
                setWorthyCreditFormUrl(questionnaireUrl);
            } catch (error) {
                setIsError(true);
            }
        };
        generateWorthyCreditFormAsync();
    }, []);

    React.useEffect(() => {
        if (worthyCreditFormUrl
            && worthyCreditFormUrl.startsWith('https://i-a.co/wc/')) {
            window.removeEventListener('message', eventHandler);
            window.addEventListener('message', eventHandler);
        }
    }, [worthyCreditFormUrl]);

    if (isError) {
        return (
            <BizonScreenWrapper>
                <div className="bizon-screen grid-container">
                    <div className="bizon-screen__content">
                        <GenericErrorLayout />
                    </div>
                </div>
            </BizonScreenWrapper>
        );
    }

    if (isIosDevice() && !isSafariBrowser()) {
        return <ModalSafariRedirect url={`${SITE_URL}/pedido/${loanApplicationId}`} />
    }

    return (
        <LoadingFallback loading={!worthyCreditFormUrl}>
            <iframe
                src={worthyCreditFormUrl}
                allow={`camera;fullscreen;accelerometer;gyroscope;magnetometer; ${worthyCreditFormUrl};`}
                className="worthy-credit-questionnaire-iframe"
            >
                <p className="text-center">Houve um problema no carregamento da página</p>
            </iframe>
        </LoadingFallback>
    );
};

export default WorthyCreditQuestionnaire;
